import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyDyslexia(enabled) {
  toggleHtmlClass(CLASSES.dyslexia, enabled);
}
